import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const CoinHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: "#002035",
      fontFamily: "Roobert",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "19px",
      letterSpacing: "-0.32px",
      [theme.breakpoints.up("md")]: {
        fontSize: "19px",
      },
    },
    ticker: {
      color: "#002035",
      fontFamily: "Söhne",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "17px",
      [theme.breakpoints.up("md")]: {
        fontSize: "16px",
      },
    },
    value: {
      color: "#002035",
      fontFamily: "Roobert",
      fontSize: "19px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "23px",
      letterSpacing: "-0.38px",
      [theme.breakpoints.up("md")]: {
        fontSize: "28px",
      },
    },
    increasedContainer: {
      display: "flex",
      padding: "4px 8px",
      alignItems: "center",
      gap: "4px",
      borderRadius: "8px",
      background: "#C4FCE9",
      marginRight: "8px",
    },
    decreasedContainer: {
      display: "flex",
      padding: "4px 8px",
      alignItems: "center",
      gap: "4px",
      borderRadius: "8px",
      marginRight: "8px",
      background: "#FEDBDB",
    },
    text: {
      color: "#022B1D",
      fontFamily: "Söhne",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "17px",
    },
    logoImage: {
      borderRadius: "50%",
      height: "35px",
      width: "35px",
    },
  }),
);
